import { RootState } from "@/app/stores"

export const selectRestaurantMenuAnalyticsFilters = (state: RootState) => state.restaurantMenuAnalytics
export const selectRestaurantMenuAnalyticsPeriod = (state: RootState) => state.restaurantMenuAnalytics.period
export const selectRestaurantMenuAnalyticsMenuIds = (state: RootState) => state.restaurantMenuAnalytics.menuIds
export const selectRestaurantMenuAnalyticsStatuses = (state: RootState) => state.restaurantMenuAnalytics.statuses
export const selectRestaurantMenuAnalyticsTableId = (state: RootState) => state.restaurantMenuAnalytics.tableId
export const selectRestaurantMenuAnalyticsPage = (state: RootState) => state.restaurantMenuAnalytics.page
